import { useRef, useState } from 'react';
import toaster from 'utils/toaster';
import aiContextService from '../service';
import { REFERENCE_LINKS_PREFIX, TOAST_CONFIG } from '../constants';

const useReferenceLinkAccess = translate => {
    const [statusByUrl, setStatusByUrl] = useState({});
    const [verifyingUrls, setVerifyingUrls] = useState(() => new Set());
    const verifyQueueRef = useRef(Promise.resolve());

    const setUrlVerifying = (url, verifying) => {
        setVerifyingUrls(prev => {
            const next = new Set(prev);
            if (verifying) {
                next.add(url);
            } else {
                next.delete(url);
            }
            return next;
        });
    };

    const checkAccess = url => {
        if (!url || verifyingUrls.has(url)) return;
        setUrlVerifying(url, true);
        verifyQueueRef.current = verifyQueueRef.current
            .then(() => aiContextService.verifyReferenceLinks([url]))
            .then(({ results }) => {
                setStatusByUrl(prev => {
                    const next = { ...prev };
                    results.forEach(result => {
                        if (result && typeof result.url === 'string') {
                            next[result.url] = result.status;
                        }
                    });
                    return next;
                });
            })
            .catch(() => toaster.error(translate(`${REFERENCE_LINKS_PREFIX}.VERIFY_FAILED`), TOAST_CONFIG))
            .finally(() => setUrlVerifying(url, false));
    };

    return {
        statusFor: url => statusByUrl[url],
        isVerifying: url => verifyingUrls.has(url),
        checkAccess,
    };
};

export default useReferenceLinkAccess;
